import styled from 'styled-components'

export const Fill = styled.section`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  flex-grow: 1;
`
